import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { ColumnSelectionModule } from '../../columns/column-selection/column-selection.module';
import { FilterSelectionComponent } from './filter-selection.component';

@NgModule({
  declarations: [FilterSelectionComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    ColumnSelectionModule,
  ],
  exports: [FilterSelectionComponent],
  providers: [],
})
export class FilterSelectionModule {}
